import { IndicatorConfig } from '../../../elements/keyIndicators/types';
import { ContentInstructions, CoreContents, FromSettingsInstruction, ListMenuItem } from '../../../types';
import { DataOptionsFactory } from '../data';
import { ContentFactory } from './base';

export type KeyIndicatorOptions = {
  data?: DataOptionsFactory;
  grouping: string | FromSettingsInstruction;
  indicators: IndicatorConfig[];
  fixedItems?: string[] | FromSettingsInstruction;
  limitedItems?: string[] | FromSettingsInstruction;
  limitedOptions?: ListMenuItem[];
  limitTo?: string[] | FromSettingsInstruction;
  addLinkLabel?: string;
  // isAllowedToDisplayEmptyState should be added on just one content to display the empty state when there is no data
  isAllowedToDisplayEmptyState?: boolean;
};

export class KeyIndicatorsFactory extends ContentFactory {
  constructor(options: KeyIndicatorOptions) {
    const {
      data,
      grouping,
      indicators,
      fixedItems,
      limitedItems,
      limitedOptions,
      addLinkLabel,
      isAllowedToDisplayEmptyState,
    } = options;

    const instructions: ContentInstructions = {
      grouping:
        typeof grouping === 'string'
          ? {
              type: 'StringInstruction',
              instruction: grouping,
            }
          : grouping,
      indicators: {
        type: 'ObjectInstruction',
        instruction: indicators,
      },
      isAllowedToDisplayEmptyState: { type: 'BooleanInstruction', instruction: isAllowedToDisplayEmptyState },
    };

    if (fixedItems) {
      instructions.fixedItems = Array.isArray(fixedItems)
        ? {
            type: 'StringListInstruction',
            instruction: fixedItems,
          }
        : fixedItems;
    }

    if (limitedItems) {
      instructions.limitedItems = Array.isArray(limitedItems)
        ? {
            type: 'StringListInstruction',
            instruction: limitedItems,
          }
        : limitedItems;
    }

    if (limitedOptions) {
      instructions.limitedOptions = {
        type: 'ObjectInstruction',
        instruction: limitedOptions,
      };
    }

    if (addLinkLabel) {
      instructions.addLinkLabel = {
        type: 'StringInstruction',
        instruction: addLinkLabel,
      };
    }

    super(CoreContents.keyIndicators, {
      data: data || DataOptionsFactory.asReceiver(),
      instructions,
    });
  }
}
